import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  NativeDateModule
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ClaimDetailFeatureModule } from '@amfam/claim/detail/feature';
// Drp Search Lib
import { ClaimDrpSearchFeatureModule } from '@amfam/claim/drp-search/feature';
// services
import { ClaimDynamicFnolDataAccessFnolModule } from '@amfam/claim/dynamic-fnol/data-access';
import { ClaimEnterpriseDataAccessModule } from '@amfam/claim/enterprise/data-access';
// Claim Overview Lib
// Photo Upload
import { ClaimPhotoUploadFeatureModule } from '@amfam/claim/photo-upload/feature';
import { ClaimPostFnolFeatureModule } from '@amfam/claim/post-fnol/feature';
import { ClaimSharedClaimListModule } from '@amfam/claim/shared/claim-list';
import { ClaimSharedRiskSelectionModule } from '@amfam/claim/shared/risk-selection';
// components/directives/pipes
import { MY_NATIVE_DATE_FORMATS } from '@amfam/shared/models';
import { ProgressIndicatorStoreModule, UiKitModule } from '@amfam/ui-kit';

// application modules
import { SharedModule } from '../shared/shared.module';
import { ClaimResolve } from './claim-routing-resolver.service';
import {
  ContactAdjusterComponent,
  ContactAdjusterConfirmationComponent,
  ContactAdjusterFormComponent
} from './contact-adjuster';
import { ContactAdjusterService } from './contact-adjuster/contact-adjuster.service';
import { PostFnolWrapperComponent } from './post-fnol/post-fnol-wrapper.component';
import { ReportClaimCallUsComponent } from './report-claim-fnol/report-claim-call-us/report-claim-call-us.component';
import { ReportClaimContactInfoComponent } from './report-claim-fnol/report-claim-contact-info/report-claim-contact-info.component';
import { ReportClaimDuplicateComponent } from './report-claim-fnol/report-claim-duplicate/report-claim-duplicate.component';
import { ReportClaimFnolComponent } from './report-claim-fnol/report-claim-fnol.component';
import { ReportClaimIncidentLocationComponent } from './report-claim-fnol/report-claim-incident-location';
import { ReportClaimIncidentTimeComponent } from './report-claim-fnol/report-claim-incident-time';
import { ReportClaimLossCauseComponent } from './report-claim-fnol/report-claim-loss-cause';
import { ReportClaimWhatToExpectComponent } from './report-claim-fnol/report-claim-what-to-expect';
import { ReportClaimGlassOnlyComponent } from './report-claim-glass-only/report-claim-glass-only.component';

@NgModule({
  imports: [
    SharedModule,
    ClaimDrpSearchFeatureModule,
    ClaimPostFnolFeatureModule,
    ClaimPhotoUploadFeatureModule,
    UiKitModule,
    ProgressIndicatorStoreModule,
    ClaimSharedClaimListModule,
    ClaimDetailFeatureModule,
    ClaimSharedRiskSelectionModule,
    ClaimDynamicFnolDataAccessFnolModule,
    ClaimEnterpriseDataAccessModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NativeDateModule
  ],
  declarations: [
    PostFnolWrapperComponent,
    ReportClaimDuplicateComponent,
    ContactAdjusterComponent,
    ContactAdjusterConfirmationComponent,
    ContactAdjusterFormComponent,
    ReportClaimCallUsComponent,
    ReportClaimContactInfoComponent,
    ReportClaimFnolComponent,
    ReportClaimIncidentTimeComponent,
    ReportClaimIncidentLocationComponent,
    ReportClaimLossCauseComponent,
    ReportClaimGlassOnlyComponent,
    ReportClaimWhatToExpectComponent
  ],
  exports: [ContactAdjusterConfirmationComponent, ContactAdjusterFormComponent],
  providers: [
    ClaimResolve,
    ContactAdjusterService,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ]
})
export class ClaimModule {
  constructor(@Optional() @SkipSelf() parentModule: ClaimModule) {
    if (parentModule) {
      throw new Error('ClaimModule is already loaded. Lazy load only');
    }
  }
}
